module.exports = __webpack_public_path__ + "static/media/view_claims_4.13fb6353.png";